/*! jQuery - v0.0.1 - 2014-08-28
*
* Copyright (c) 2014 Jonathan Heilmann; */
(function(e){if(typeof mfpInlineFunctions!="undefined"){e.each(mfpInlineFunctions,function(t,n){n(e)})}})(window.jQuery||window.Zepto);